import { useState } from 'react';

interface ReturnValue {
  count: number;
  decrement: () => void;
  increment: () => void;
  customizeCount: (cnt: number) => void;
}
export const useCounter = (initialCount = 1): ReturnValue => {
  const [count, setCount] = useState(initialCount);
  const decrement = () => setCount((prev) => prev - 1);
  const increment = () => setCount((prev) => prev + 1);
  const customizeCount = (cnt: number) => setCount(cnt);
  return { count, decrement, increment, customizeCount };
};
